import { useControllableState } from "@tamagui/use-controllable-state";
import { useSheetController } from "./useSheetController";
const useSheetOpenState = (props) => {
  const { isHidden, controller } = useSheetController();
  const onOpenChangeInternal = (val) => {
    var _a, _b;
    (_a = controller == null ? void 0 : controller.onOpenChange) == null ? void 0 : _a.call(controller, val);
    (_b = props.onOpenChange) == null ? void 0 : _b.call(props, val);
  };
  const [open, setOpen] = useControllableState({
    prop: (controller == null ? void 0 : controller.open) ?? props.open,
    defaultProp: props.defaultOpen ?? false,
    onChange: onOpenChangeInternal,
    strategy: "most-recent-wins",
    transition: true
  });
  return {
    open,
    setOpen,
    isHidden,
    controller
  };
};
export {
  useSheetOpenState
};
//# sourceMappingURL=useSheetOpenState.js.map
